import {
    CREATE_PURCHASE_CHALLAN_RETURN,
    DELETE_PURCHASE_CHALLAN_RETURN,
    GET_PURCHASE_CHALLAN_RETURNS,
    GET_PURCHASE_CHALLAN_RETURNS_PAGE,
    PURCHASE_CHALLAN_RETURN_REQUEST,
    PURCHASE_CHALLAN_RETURN_REQUEST_FAILURE,
    UPDATE_PURCHASE_CHALLAN_RETURN,
    SET_PURCHASE_CHALLAN_RETURN_ORDERS,
    PURCHASE_CHALLAN_RETURN_REQUEST_SUCCESS
  } from "../types/purchase-challan-return-types";
  
  const initialState = {
    purchaseChallanReturns: [],
    purchaseChallanReturnsPage: [],
    returnOrders: [],
    page: 1,
    pageSize: 10,
    search: '',
    where: {},
    total: 0,
    loading: false,
    error: null,
  };
  
  const purchaseChallanReturnReducer = (state = initialState, action) => {
    switch (action.type) {
        case PURCHASE_CHALLAN_RETURN_REQUEST: {
            return {
                ...state,
                loading: true,
                error: null
            }
        }
        case GET_PURCHASE_CHALLAN_RETURNS: {
            return {
                ...state,
                purchaseChallanReturns: [...action.payload],
                loading: false,
                error: null
            }
        }
        case GET_PURCHASE_CHALLAN_RETURNS_PAGE: {
            const { data, total, page, pageSize, search, where } = action.payload || {};
            return {
                ...state,
                purchaseChallanReturnsPage: [...data],
                total,
                page,
                pageSize,
                search: search || '',
                where: where || {},
                loading: false,
                error: null
            }
        }
        case CREATE_PURCHASE_CHALLAN_RETURN:
            return {
                ...state,
                purchaseChallanReturns: [action.payload, ...state.purchaseChallanReturns],
                loading: false,
                error: null
            };
        case UPDATE_PURCHASE_CHALLAN_RETURN:
            const purchaseChallanReturnsData = state.purchaseChallanReturns.slice(0);
            const uIndex = purchaseChallanReturnsData.findIndex((data) => data.id === action.payload.id);
            purchaseChallanReturnsData.splice(uIndex, 1, { ...action.payload.data });
            return {
                ...state,
                purchaseChallanReturns: [ ...purchaseChallanReturnsData ],
                loading: false,
                error: null
            };
        case DELETE_PURCHASE_CHALLAN_RETURN: {
            const purchaseChallanReturns = state.purchaseChallanReturns?.slice(0);
            const index = purchaseChallanReturns.findIndex((data) => data.id === action.id);
            if (index > -1) {
                purchaseChallanReturns.splice(index, 1);
            }
            return {
                ...state,
                purchaseChallanReturns: [...purchaseChallanReturns],
                loading: false,
                error: null
            }
        }
        case SET_PURCHASE_CHALLAN_RETURN_ORDERS: {
            return {
                ...state,
                returnOrders: [...action.payload],
                loading: false,
                error: null
            }
        }
        case PURCHASE_CHALLAN_RETURN_REQUEST_SUCCESS: {
            return {
                ...state,
                loading: false,
                error: null
            }
        }
        case PURCHASE_CHALLAN_RETURN_REQUEST_FAILURE: {
            return {
                ...state,
                loading: false,
                error: action.error
            }
        }
        default:
            return state;
        }
    };
  
  export default purchaseChallanReturnReducer;
  